export const INVOICE_PAGE_SIZE = 10;

export const INVOICE_COLORS = {
  navy: '#1E3878',
  navySoft: 'rgba(30, 56, 120, 0.2)',
  navyHover: 'rgba(30, 56, 120, 0.07)',
  green: '#53C295',
  greenDark: '#46AC83',
  pageBg: '#F8F8F8',
  cardBg: '#F8F8F8',
  border: '#E0E0E0',
  borderLight: '#D8D8D8',
  textPrimary: '#1E3878',
  textSecondary: '#6B7280',
  textMuted: '#9AA3B2',
  rowHover: 'rgba(30, 56, 120, 0.03)',
  sidebarActiveBg: 'rgba(30, 56, 120, 0.08)',
};

export const INVOICE_RADIUS = {
  card: '20px',
  input: '12px',
  button: '12px',
  dialog: '16px',
};
